import './App.css';
import React from 'react';
import Header from './components/Header';
import HomePage from './components/HomePage'
import Projects from './components/Projects'
import Blog from './components/Blog'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
function App() {

 return (   
            <>
                 
               <Router>
               <Header />
                 <Routes>
                     <Route exact path='/' element={<HomePage/>}/>
                     <Route path='/projects' element={<Projects/>}/>
                     <Route path='/blog' element={<Blog/>}/>
                  </Routes>
               
               </Router> 
              
            </>
           
 )
}

export default App;
